import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showForgot, setShowForgot] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const { data } = await api.post('/auth/login', { username, password });
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data));
      localStorage.removeItem('loginSource'); // direct login → logout returns here, not portal
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    }
    setLoading(false);
  };

  const handleSetup = async () => {
    try {
      const { data } = await api.post('/auth/setup');
      setError('');
      setUsername('admin');
      setPassword('admin123');
      alert(`Admin created!\nUsername: ${data.username}\nPassword: ${data.password}`);
    } catch (err) {
      setError(err.response?.data?.error || 'Setup failed');
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #1e293b 100%)'
    }}>
      {showForgot && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999 }}>
          <div style={{ background: '#fff', borderRadius: 14, padding: 32, width: 380, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
            <div style={{ textAlign: 'center', marginBottom: 20 }}>
              <div style={{ fontSize: 40, marginBottom: 12 }}>🔐</div>
              <h3 style={{ fontWeight: 700, color: '#0f172a', marginBottom: 8 }}>Forgot Password?</h3>
              <p style={{ fontSize: 14, color: '#64748b', lineHeight: 1.6 }}>
                Password reset is managed by your system administrator.
              </p>
            </div>
            <div style={{ background: '#f0fdf4', border: '1px solid #86efac', borderRadius: 10, padding: 16, marginBottom: 20 }}>
              <div style={{ fontSize: 13, color: '#15803d', lineHeight: 1.7 }}>
                <div style={{ fontWeight: 600, marginBottom: 4 }}>Contact your Admin:</div>
                <div>• Ask the admin to reset your password</div>
                <div>• Admin can use <strong>Users → 🔑 Reset</strong></div>
                <div>• Default reset password: <strong>Welcome@123</strong></div>
                <div>• Change it after login using <strong>🔑 Change Password</strong></div>
              </div>
            </div>
            <button className="btn-primary" onClick={() => setShowForgot(false)} style={{ width: '100%' }}>Back to Login</button>
          </div>
        </div>
      )}
      <div style={{ width: 400, background: '#fff', borderRadius: 16, padding: 40, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 28, fontWeight: 700, color: '#0f172a' }}>CLTS PM Center</div>
          <div style={{ fontSize: 14, color: '#64748b', marginTop: 4 }}>Project Management</div>
        </div>

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#374151', marginBottom: 6 }}>Username or Email</label>
            <input value={username} onChange={e => setUsername(e.target.value)} placeholder="Enter username or email" />
          </div>
          <div style={{ marginBottom: 20 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
              <label style={{ fontSize: 13, fontWeight: 500, color: '#374151' }}>Password</label>
              <button type="button" onClick={() => setShowForgot(true)} style={{ background: 'none', border: 'none', color: '#3b82f6', fontSize: 12, cursor: 'pointer', padding: 0 }}>Forgot password?</button>
            </div>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter password" />
          </div>

          {error && <div style={{ color: '#dc2626', fontSize: 13, marginBottom: 12, padding: '8px 12px', background: '#fee2e2', borderRadius: 8 }}>{error}</div>}

          <button type="submit" className="btn-primary" disabled={loading}
            style={{ width: '100%', padding: 12, fontSize: 15, fontWeight: 600 }}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <button onClick={handleSetup} style={{
            background: 'transparent', color: '#6b7280', fontSize: 12, border: 'none', cursor: 'pointer', textDecoration: 'underline'
          }}>First time? Create admin account</button>
        </div>
      </div>
    </div>
  );
}
